import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", {
        class: _normalizeClass(_ctx.containerClass),
        onMousemove: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.onMouseMove && _ctx.onMouseMove(...args)))
    }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { id: "mol-viewer" }, null, -1)
        ]))], 34));
}
